export var AutomaticTaskType;
(function (AutomaticTaskType) {
    AutomaticTaskType[AutomaticTaskType["None"] = 0] = "None";
    AutomaticTaskType[AutomaticTaskType["VehicleDriverMissing"] = 1] = "VehicleDriverMissing";
    AutomaticTaskType[AutomaticTaskType["VehicleCapacity"] = 2] = "VehicleCapacity";
    AutomaticTaskType[AutomaticTaskType["RouteUnassignedAttendees"] = 3] = "RouteUnassignedAttendees";
})(AutomaticTaskType || (AutomaticTaskType = {}));
